import React from 'react';
import PropTypes from 'prop-types';
import autosize from 'autosize';
import LinnerDiv from './lineDiv';
import intialData, { localsMessages } from '../utility/getTemplateData';
import * as AppActions from '../actions/AppActions';
import AppStore from '../stores/AppStore';
import { addClass, removeClass } from '../utility/domUtils';
import { isExternalFlow } from '../utility/externalIntegrationUtils';
import isEmpty from 'lodash/isEmpty';
import * as FPT from '../utility/fpt';
import { EVENT_NAME } from '../utility/constants';
import NoteFieldError from './NoteFieldError';

let messages = localsMessages('common/note');
const MAX_CHAR_LIMIT = 250;

class NoteComponent extends React.Component {
  constructor(props) {
    super(props);
    const donationNote =
      AppStore.getDonationNote() || intialData.donationNote || '';

    this.state = {
      donationNote,
      height: 50,
      showLabel: isEmpty(donationNote),
      showError: false,
    };
  }

  componentDidMount() {
    autosize(document.querySelector('textarea'));
  }

  handleClick = () => {
    if (isExternalFlow()) {
      FPT.trackEventName(EVENT_NAME.DW_GIVING_DONATE_SETUP_COMMENT_PRESSED);
    }
    FPT.trackLinkClick('note_pad');
    this.setState(
      {
        showLabel: false,
      },
      () => {
        this.textArea.focus();
      }
    );
  };

  handleBlur = (event) => {
    if (event.target.value) {
      AppActions.changeNote({ note: event.target.value });
    } else {
      AppActions.changeNote({ note: '' });
      this.setState({
        showLabel: true,
      });
    }
  };
  showNoteFieldError = () => {
    this.setState({
      showError: true,
    });
  };
  hideNoteFieldError = () => {
    this.setState({
      showError: false,
    });
  };

  handleOnChange = (event) => {
    if (event.target.value && event.target.value.length >= MAX_CHAR_LIMIT) {
      addClass('.note_wrap', ['animated', 'shake']);
      setTimeout(() => {
        removeClass('.note_wrap', ['animated', 'shake']);
      }, 1000);
      this.showNoteFieldError();
      return false;
    }
    this.hideNoteFieldError();
  };

  renderSvgPencil() {
    return (
      <div style={{ width: 15, marginRight: 10, display: 'inline-block' }}>
        <svg
          style={{
            display: 'inline',
            height: 14,
            width: 14,
            marginTop: 6,
            marginRight: 10,
            fill: 'none',
            stokeWidth: 1,
            stroke: 'grey',
          }}
          viewBox="0 0 14.2 14.22"
        >
          <g>
            <polyline points="6.86 4.17 1.14 9.9 0.5 13.72 4.32 13.08 10.04 7.36" />
            <path d="M5.14,14,3.23,12.14" transform="translate(-0.82 -0.96)" />
            <path
              d="M12.61,6.57,9.43,3.39"
              transform="translate(-0.82 -0.96)"
            />
            <path
              d="M10.86,2h0a1.89,1.89,0,0,1,2.66.11l.41.41A1.94,1.94,0,0,1,14,5.14h0"
              transform="translate(-0.82 -0.96)"
            />
          </g>
        </svg>
      </div>
    );
  }

  render() {
    let {
      note: { label = '' } = {},
      error: { lengthLimit = '' } = {},
    } = messages.note;

    if (intialData.charityNoteEnabled && intialData.charityNoteLabel) {
      label = intialData.charityNoteLabel;
    }

    if (this.props.label) {
      label = this.props.label;
    }

    return (
      <div>
        <div
          className={`ppvx_row ${
            isExternalFlow()
              ? 'client_note_wrapper'
              : 'text-center donate_note_wrapper'
          }`}
        >
          {this.state.showLabel ? (
            <label
              htmlFor="note"
              onClick={this.handleClick}
              tabIndex="0"
              onKeyDown={this.handleClick}
            >
              {this.renderSvgPencil()}
              <span>{label}</span>
            </label>
          ) : (
            <div className="note_wrap" tabIndex="0">
              <textarea
                id="note"
                name="note"
                maxLength={MAX_CHAR_LIMIT}
                style={{ height: this.state.height }}
                onChange={this.handleOnChange}
                onBlur={this.handleBlur}
                tabIndex="0"
                ref={(el) => (this.textArea = el)}
              >
                {this.state.donationNote}
              </textarea>
            </div>
          )}
          {this.state.showError && <NoteFieldError errorText={lengthLimit} />}
        </div>
        <LinnerDiv />
      </div>
    );
  }
}

NoteComponent.propTypes = {
  label: PropTypes.string,
};

export default NoteComponent;
